import { ApiPersistenceProvider } from './apiProvider';
import { LocalPersistenceProvider } from './localProvider';
import type { PersistenceProvider } from './types';

export type { PersistenceProvider } from './types';
export { loadThemeCache } from './localProvider';

const useApi =
  import.meta.env.VITE_USE_API === 'true' ||
  import.meta.env.PROD;

let provider: PersistenceProvider | null = null;

export function getPersistence(): PersistenceProvider {
  if (!provider) {
    provider = useApi
      ? new ApiPersistenceProvider()
      : new LocalPersistenceProvider();
  }
  return provider;
}

export function resetPersistenceForTests(): void {
  provider = null;
}
